import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";

function EmiSuccess() {
  const [params] = useSearchParams();
  const uniqId = params.get("uniq_id");
  const [status, setStatus] = useState("Loading...");
  const [details, setDetails] = useState(null);

  useEffect(() => {
    if (!uniqId) {
      setStatus("Missing mandate ID");
      return;
    }

    fetch(`https://kolibusiness.com/backend/get-mandate-status.php?id=${uniqId}`)
      .then(res => res.json())
      .then(data => {
        if (data?.StatusCode === "NP000") {
          const mandate = data.data?.mandate || {};
          setDetails(mandate);
          setStatus(`✅ ${mandate.status || "Authorized"}`);
        } else {
          setStatus("❌ Failed to fetch status.");
        }
      })
      .catch(err => {
        console.error("Mandate status error:", err);
        setStatus("❌ Network error.");
      });
  }, [uniqId]);

  return (
    <div style={{ maxWidth: 600, margin: "40px auto", padding: 30, textAlign: "center", background: "#fff", borderRadius: 10, boxShadow: "0 0 15px rgba(0,0,0,0.1)" }}>
      <h2>EMI Mandate Status</h2>
      <p style={{ fontSize: 18 }}>{status}</p>
      {uniqId && <p><strong>Mandate ID:</strong> {uniqId}</p>}
      {details && (
        <div style={{ marginTop: 20 }}>
          <p><strong>Customer:</strong> {details.account_holder_name}</p>
          <p><strong>Bank:</strong> {details.bank_account_no}</p>
          <p><strong>Status:</strong> {details.status}</p>
        </div>
      )}
    </div>
  );
}

export default EmiSuccess;
